import React from 'react'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'

import FeedbackMobile from './FeedbackMobile'
import FeedbackDesktop from './FeedbackDesktop'
import LoadImage from '../../LoadImage'

import '../../../styles/components/feedback-layout.scss'

const FeedbackLayout = ({
  reviewImagesSm,
  reviewImagesLg
}) => {
  const breakpoint = useBreakpoint()

  let content = null

  if (reviewImagesLg.length == 1) {
    content = (
      <LoadImage
        primaryLg={ reviewImagesLg[0].imageWebp }
        secondaryLg={ reviewImagesLg[0].imageJpg }
        className="feedback-single-image"
        alt="Feedback image"
        secondaryType="jpg"
        lazyLoad
      />
    )
  } else {
    content = breakpoint.md ?
      <FeedbackMobile reviewImages={ reviewImagesSm } /> :
      <FeedbackDesktop reviewImages={ reviewImagesLg } />
  }

  return (
    <section className="feedback-redesign">
      <h2 className="caption-primary">Feedback</h2>
      { content }
    </section>
  )
}

export default FeedbackLayout